import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0222',
    ecrans: ['00-2'],
    params: [
        '?reference'
    ]
});
